export const id = {
  welcome: 'selamat datang',
  logout: 'keluar',
  trading_accounts: 'akun trading',
  account_list: 'daftar akun',
  create_live_account: 'buat akun live',
  upgrade_to_live_account: 'upgrade ke akun live',
  create_demo_account: 'buat akun demo',
  finance: 'keuangan',
  deposit_funds: 'dana deposit',
  withdraw_funds: 'menarik dana',
  internal_transfer: 'transfer internal',
  external_transfer: 'transfer eksternal',
  transfer_back: 'mentransfer kembali',
  transfer_back_to_my_local_depositor: 'mentransfer kembali ke depositor lokal saya',
  transfer_to_external_account: 'transfer ke akun eksternal',
  payment_history: 'riwayat pembayaran',
  my_cards: 'kartu saya',
  my_profile: 'Profil saya',
  personal_information: 'informasi pribadi',
  change_password: 'ganti kata sandi',
  upload_documents: 'upload dokumen',
  partner: 'partner',
  overview: 'gambaran umum',
  clients: 'klien',
  sub_ibs: 'sub ib',
  payout: 'pembayaran',
  marketing_material: 'materi marketing',
  withdrawal_history: 'riwayat penarikan',
  become_a_partner: 'menjadi partner',
  please_fill_the_following_fields: 'silakan isi kolom berikut',
  what_geographic_region: 'Wilayah geografis mana yang akan Anda targetkan?',
  submit: 'kirim',
  upload_documents_notice: 'Untuk sepenuhnya menyetujui akun Anda dan dapat berdagang, <a>harap unggah dokumen </a> dan lengkapi profil Anda',
  change_password_ta_notice: 'Setiap akun perdagangan baru akan menggunakan password baru Anda. Ini tidak memengaruhi akun trading Anda saat ini.',
  changepass_error: 'Password saat ini salah, harap coba lagi.',
  changepass_success: 'Password berhasil diubah',
  current_password: 'password saat ini',
  new_password: 'password baru',
  confirm_new_password: 'konfirmasi password baru',
  pending_account: 'akun tertunda',
  account_must_be_approved_message: 'Akun Anda harus disetujui sebelum membuat akun trading live baru.',
  new_trading_account_message: 'Akun trading baru berhasil dibuat',
  password_generated_for_ta: 'Password telah dibuat dan dikirim ke email Anda untuk akun trading baru Anda',
  new_trading_account_type_message: 'Akun trading {type} baru berhasil dibuat',
  choose_your_desired_trading_platform_and_settings: 'Pilih platform dan pengaturan trading yang Anda inginkan',
  select_leverage: 'pilih leverage',
  create: 'buat',
  select_account_type: 'pilih jenis akun',
  select_currency: 'pilih mata uang',
  no_trading_account_found: 'Tidak ada akun trading yang ditemukan.',
  bankwire_notice:
    'Terima kasih telah mengirimkan detail bank Anda. Kami akan mendaftarkan detail Anda ke bank kami.<br><br> Anda akan menerima detail transfer melalui email dalam waktu 24 jam bersama dengan referensi pembayaran pribadi Anda. Anda dapat menggunakan perincian ini untuk setoran apa pun di masa mendatang.<br><br> <strong>PENTING:</strong> Referensi pembayaran dipersonalisasi untuk satu klien. Jika Anda tidak menggunakan referensi pembayaran yang Anda terima, kami tidak akan dapat menerima deposit Anda. Tidak ada pihak ketiga yang dapat menggunakan referensi pembayaran yang sama.',
  deposit: 'deposit',
  account_details: 'detail akun',
  enter_fasapay_id: 'Silakan masukkan ID Akun Fasapay Anda:',
  account_id: 'ID Akun',
  secure_id: 'Keamanan ID',
  continue: 'lanjutkan',
  bankwire_deposit_details_notice:
    'Bank kami memerlukan detail bank Anda untuk memproses deposit Anda. Setiap deposit yang dilakukan melalui Wire Transfer akan dikembalikan ke akun yang sama dengan yang Anda depositkan.',
  bankwire_withdrawal_details_notice:
    'Bank kami memerlukan detail bank Anda untuk memproses penarikan Anda. Penarikan apa pun yang dilakukan melalui Transfer Bank akan dikembalikan ke akun yang sama dengan yang Anda setorkan.',
  bankwire_verify_account_notice:
    '<p>Anda perlu memverifikasi akun Anda sebelum menggunakan Transfer Bank. Silakan <a href="{FSROOT_URL}upload-documents">upload dokumen Anda</a></p>',
  bankwire_amount_label: 'Jumlah ({minDeposit} setoran min.)',
  bank_name: 'nama bank',
  full_name: 'nama lengkap',
  deposit_methods: 'metode deposit',
  deposit_select_ta_p: 'Silakan pilih akun trading yang dananya ingin Anda setorkan ke:',
  coming_soon: 'segera',
  amount: 'jumlah',
  proof_of_id: 'Bukti identitas',
  proof_of_id_instructions: 'Bukti identitas',
  documents_must_contain_all_of_the_following_details: 'Dokumen harus memenuhi persyaratan berikut:',
  your_full_name: 'Nama lengkap Anda',
  a_unique_id_number: 'Nomor ID',
  your_birthdate: 'Tanggal lahir ',
  your_place_of_birth: 'Tempat lahir',
  a_visible_photo: 'Foto yang terlihat',
  your_signature: 'Tanda tangan Anda',
  your_nationality: 'kewarganegaraan Anda',
  proof_of_residence_instructions: 'Download tagihan utilitas atau laporan mutasi bank Anda.',
  your_residential_address: 'Alamat tempat tinggal Anda',
  date_of_issue: 'Tanggal diterbitkan',
  other: 'lainnya',
  other_documents_instructions: 'Dokumen lain yang telah diminta oleh departemen verifikasi kami.',
  deposit_failed: 'Deposit gagal',
  deposit_successful: 'Deposit berhasil',
  already_logged_in: 'Sudah masuk',
  login: 'masuk',
  create_an_account: 'buat akun',
  partner_clients: 'Partner - Klien',
  trades: 'perdagangan',
  client_id: 'ID klien',
  trading_account: 'akun trading',
  metatrader_web_client: 'klien web metatrader',
  platform: 'platform',
  order: 'pesanan',
  pair: 'pasangan',
  volume: 'volume',
  close_date: 'tanggal tutup',
  commission: 'komisi',
  status: 'status',
  total_commission_generated: 'total komisi yang dihasilkan',
  total_deposits: 'jumlah deposit',
  total_withdrawals: 'total penarikan',
  date_joined: 'tanggal bergabung',
  more: 'lagi',
  banners: 'spanduk',
  partner_marketing_material: 'Partner - Materi pemasaran',
  partner_overview: 'Partner - Gambaran Umum',
  partner_payout: 'Partner - Pembayaran',
  partner_payout_request_message: 'Permintaan Anda telah dicatat.',
  select_your_default_payment_option: 'Pilih opsi pembayaran bawaan Anda:',
  beneficiary_name_on_account: 'Penerima Dana (Nama pada rekening)',
  bank_address: 'Alamat bank',
  sort_code: 'sort code (untuk Klien UK)',
  your_provider_email: 'Email {provider} Anda',
  select: 'pilih',
  next: 'berikutnya',
  please_confirm_your_bank_details: 'Harap konfirmasi detail bank Anda:',
  bank: 'bank',
  sub_partners: 'Sub Partner',
  state: 'negara',
  date: 'tanggal',
  internal_transfer_instructions:
    'Anda dapat mentransfer dana antar akun trading Anda.<br> Silahkan masukkan jumlah transfer yang diinginkan dan pilih sumber rekening dan tujuan.<br> Transfer internal segera diproses.',
  transfer_complete: 'transfer selesai',
  transfer_from: 'transfer dari',
  internal_transfer_processed_successfully: 'Transfer internal berhasil diproses.',
  external_transfer_processed_successfully: 'Transfer eksternal berhasil diproses.',
  select_account: 'pilih akun',
  to: 'ke',
  warning_currency_conversion_will_take_place: 'peringatan: konversi mata uang akan dilakukan',
  transfer: 'transfer',
  account: 'akun',
  currency: 'mata uang',
  balance: 'keseimbangan ',
  equity: 'ekuitas',
  download: 'unduh',
  launch: 'meluncurkan',
  email: 'surel',
  password: 'kata sandi',
  forgot: 'lupa',
  forgot_password: 'lupa kata sandi',
  risk_warning_footer:
    'Peringatan risiko: Perdagangan produk dengan leverage seperti Forex dan CFD mungkin tidak cocok untuk semua investor karena membawa tingkat risiko terhadap modal Anda. Harap pastikan bahwa Anda sepenuhnya memahami risiko yang terlibat, dengan mempertimbangkan tujuan investasi dan tingkat pengalaman Anda, sebelum melakukan perdagangan, dan jika perlu mencari saran independen. Harap selengkapnya baca <a href="{riskURL}">Pengungkapan Risiko</a>.',
  error_contact_support: 'Ada yang tidak sesuai, hubungi layanan pelanggan.',
  type: 'tipe',
  funded: 'didanai',
  username: 'nama pengguna',
  company_name: 'nama perusahaan',
  website: 'situs web',
  first_name: 'nama depan',
  last_name: 'nama belakang',
  date_of_birth: 'tanggal lahir',
  gender: 'jenis kelamin',
  phone: 'telepon',
  dial_code: 'kode panggil',
  country: 'negara',
  address: 'alamat',
  year_moved_to_address: 'tahun pindah ke alamat',
  post_code: 'kode Pos',
  selected_currency: 'mata uang yang dipilih',
  january: 'januari',
  february: 'februari',
  march: 'maret',
  april: 'april',
  may: 'mei',
  june: 'juni',
  july: 'juli',
  august: 'agustus',
  september: 'september',
  october: 'oktober',
  november: 'november',
  december: 'desember',
  already_have_an_account: 'sudah memiliki akun',
  invalid_request_login_required: 'permintaan tidak valid, Anda harus login terlebih dahulu.',
  register_accounttype_account: 'daftarkan akun {accountType}',
  client_type: 'tipe klien',
  individual: 'individu',
  company: 'perusahaan',
  company_information: 'informasi perusahaan',
  company_website: 'situs perusahaan',
  complete_live_registration: 'menyelesaikan pendaftaran secara langsung',
  title: 'judul',
  confirm_password: 'konfirmasi sandi',
  select_country: 'pilih negara',
  phone_number: 'nomor telepon',
  choose_trading_platform: 'pilih platform trading',
  select_option: 'pilih opsi',
  day: 'hari',
  month: 'bulan',
  year: 'tahun',
  company_registration_information: 'informasi pendaftaran perusahaan',
  date_of_registration: 'tanggal pendaftaran',
  select_nationality: 'pilih kewarganegaraan',
  nationality: 'kewarganegaraan',
  select_gender: 'pilih jenis kelamin',
  male: 'pria',
  female: 'perempuan',
  address_line: 'alamat',
  city_town: 'kota',
  state_province: 'provinsi',
  select_year: 'pilih tahun',
  year_moved_to_current_address: 'tahun pindah ke alamat saat ini',
  company_shareholders_directors: 'pemegang saham & direktur perusahaan',
  number_of_shareholders: 'jumlah pemegang saham',
  number_of_directors: 'jumlah direktur',
  shareholder: 'pemegang saham',
  financial_information: 'informasi keuangan',
  total_estimated_net_worth: 'total taksiran kekayaan bersih (€)?',
  less_than_amount: 'kurang dari {jumlah}',
  over_amount: 'lebih dari {jumlah}',
  total_estimated_annual_income: 'perkiraan total pendapatan tahunan (€)?',
  employment_information: 'informasi ketenagakerjaan',
  employment_status: 'status pekerjaan',
  employed: 'karyawan',
  self_employed: 'wiraswasta',
  retired: 'pensiun',
  student: 'pelajar',
  unemployed: 'pengangguran',
  source_of_income: 'sumber penghasilan',
  employment: 'pekerjaan',
  inheritance: 'warisan',
  investment: 'investasi',
  trading_experience: 'pengalaman perdagangan',
  forex_cfds_and_other_instruments: 'forex, cfds dan instrumen lainnya',
  yes: 'Ya',
  no: 'Tidak',
  lose_capital_risk:
    'Produk derivatif cocok sebagai bagian dari tujuan investasi dan sikap saya terhadap risiko dan saya dapat menilai risiko yang terlibat dalam memperdagangkannya, termasuk kemungkinan saya kehilangan semua modal saya',
  prev_pro_qualifications: 'Saya memiliki kualifikasi profesional sebelumnya dan/atau pengalaman kerja di industri jasa keuangan',
  account_type: 'jenis akun',
  choose_currency: 'pilih mata uang',
  tos_with_link: 'Saya telah membaca, memahami, dan menerima syarat dan ketentuan serta pengungkapan peringatan risiko <a target="_blank" href="{URL}">di sini</a>',
  registration_successful: 'registrasi berhasil',
  reset_password_invalid_link: 'tautan setel ulang Anda tidak valid, harap coba lagi atau hubungi layanan pelanggan.',
  reset_account_password: 'setel ulang password akun',
  choose_your_new_password: 'pilih password baru Anda',
  reset_password: 'setel ulang password',
  file_upload_failed_filename: 'download yang diminta untuk file {filepath} gagal.',
  withdrawal_request_success_message: 'permintaan penarikan Anda telah berhasil',
  withdraw: 'penarikan',
  please_fill_the_following: 'silahkan isi berikut ini',
  cancel: 'membatalkan',
  withdraw_select_ta_p: 'Silakan pilih akun trading yang ingin Anda tarik dari:',
  free_margin_change_warning: 'Harap perhatikan bahwa penarikan harus dilakukan dengan metode yang sama dengan yang Anda setorkan ke akun Anda.',
  you_need_an_ib_account_to_visit_this_page: 'Anda memerlukan akun IB untuk mengunjungi halaman ini',
  no_permission_to_to_visit_this_page: 'Anda tidak memiliki izin untuk mengunjungi halaman ini',
  you_became_a_partner_successfully: 'Anda berhasil menjadi partner EUROTRADER!',
  note_wallet_currency_conversion_partner:
    'Harap perhatikan bahwa dengan menjadi Partner, mata uang dompet Anda akan diubah menjadi USD dan setiap dana saat ini akan dikonversi ke USD dengan nilai tukar saat ini!',
  upgraded_to_a_live_account_successfully: 'Berhasil ditingkatkan ke akun live!',
  passwords_dont_match: 'Password tidak cocok',
  password_rules: 'Setidaknya 1 kapital, 1 huruf kecil, dan 1 angka (maksimal 6 hingga 16 karakter)',
  please_fill: 'tolong isi',
  partner_verify_first_notice: 'Untuk menjadi mitra, Anda harus memverifikasi akun Anda terlebih dahulu. Silakan unggah dokumen Anda <a href="upload-documents">di sini</a>',
  only_currency_format_allowed: 'hanya format mata uang yang diperbolehkan',
  please_enter_your_account_id: 'Silakan masukkan ID akun Anda',
  min_deposit_with_bankwire_is_amount: 'Min. deposit dengan transfer bank adalah {mount}',
  please_select_different_tas: 'Silakan pilih akun trading yang berbeda',
  you_need_to_accept_our_tos: 'Anda harus menyetujui Syarat dan Ketentuan kami.',
  phone_is_required: 'telepon diperlukan',
  invalid_phone_number: 'nomor telepon tidak valid',
  you_must_be_over_18: 'Anda harus berusia di atas 18 tahun.',
  year_is_required: 'Tahun diperlukan',
  leave_page_question: 'Tinggalkan halaman?',
  registration_exit_notice: 'Anda belum menyelesaikan pendaftaran Anda. Anda ingin pergi tanpa menyelesaikan?',
  internal_server_error_support: 'Kesalahan internal server. Silakan hubungi layanan pelanggan',
  please_fill_all_fields: 'Harap isi semua kolom',
  no_logs_found_for_this_client: 'Tidak ada log yang ditemukan untuk klien ini',
  no_accounts_send: 'Tidak ada akun yang dikirim',
  internal_server_error_try_again: 'Kesalahan internal server. Coba lagi nanti',
  insufficient_balance: 'Saldo tidak mencukupi',
  currency_conversion_connection_error: 'Tidak ada tanggapan dari server konversi mata uang, harap coba lagi atau hubungi layanan pelanggan.',
  currency_conversion_error: 'Kesalahan konversi mata uang, harap coba lagi atau hubungi layanan pelanggan.',
  invalid_accounts: 'Akun tidak valid',
  withdrawal_unsuccessful_equity_message: 'Penarikan gagal, ekuitas tidak cukup di akun perdagangan {TAID}',
  withdrawal_failed_free_margin: 'Penarikan gagal. Periksa kembali free margin Anda.',
  pamm_copy_server_field_message: 'silahkan salin dan tempel alamat IP ke kolom "Server" di server MT4 Anda',
  invalid_request: 'permintaan tidak valid',
  missing_shareholders_directors: 'Pemegang saham/direktur yang hilang',
  missing: 'Hilang',
  invalid_request_passwords_do_not_match: 'Permintaan tidak valid. Password tidak cocok',
  email_exists_message: 'Email sudah ada, silakan coba dengan alamat email lain.',
  your_payment_method_has_already_been_set: 'Metode pembayaran Anda telah ditetapkan. Silakan hubungi layanan pelanggan',
  payment_method_is_required_message: 'Metode pembayaran diperlukan. Silakan coba lagi atau hubungi layanan pelanggan',
  couldnt_find_your_account: 'Tidak dapat menemukan akun Anda',
  ta_limit_error_message: 'Akun Anda telah mencapai batas akun trading ({limit}) untuk {platform}.',
  error: 'kesalahan',
  account_created_successfully: 'akun berhasil dibuat',
  invalid_leverage: 'leverage tidak valid',
  insufficient_data_provided: 'data yang diberikan tidak mencukupi',
  insufficient_data_provided_missing_field: 'Data yang diberikan tidak mencukupi. Hilang {bidang}.',
  invalid_amount: 'jumlah tidak valid',
  account_taid_doesnt_exist: 'Akun {TAID} tidak ada',
  withdrawal_unsuccessful_equity_taid: 'Penarikan gagal, ekuitas tidak cukup di akun trading {TAID}',
  withdrawal_unsuccessful_free_margin_taid: 'Penarikan gagal, free margin idak cukup di akun trading {TAID}',
  internal_server_error: 'Kesalahan internal server',
  deposit_failed_support: 'Deposit tidak berhasil, harap hubungi layanan pelanggan.',
  upload_documents_instructions: 'Harap berikan dokumen-dokumen berikut kepada kami.<br> File harus dalam format PDF, JPG, atau PNG dan tidak boleh melebihi 5mb.',
  total_earned: 'total yang diperoleh',
  total_paid: 'total dibayar',
  total_clients: 'jumlah klien',
  total_sub_ibs: 'jumlah sub ib',
  see_trading_accounts: 'lihat akun trading',
  see_trades: 'lihat perdagangan',
  welcome_title_live: 'Terima kasih telah membuka akun Anda dengan EUROTRADER!',
  welcome_title_demo: 'Terima kasih telah membuka akun demo Anda dengan EUROTRADER!',
  welcome_title_ib: 'Terima kasih telah membuka Partner akun Anda dengan EUROTRADER!',
  welcome_text_live:
    '<p>Untuk dapat melakukan deposit, disetujui, dan siap berdagang, Anda perlu menyelesaikan langkah-langkah berikut:</p> <ul><li>Masuk ke Portal Klien Eurotrader Anda</li> <li>Unggah dokumen</li> <li>Lakukan deposit ke akun Anda</li> <li>Mulai trading!</li></ul> <p>Jika Anda memerlukan bantuan, tim layanan pelanggan kami yang ramah tersedia 24/5. Untuk menghubungi mereka, klik <a href="{contactURL}" target="_blank">di sini</a></p>',
  welcome_text_demo:
    '<p>Untuk dapat melakukan deposit, disetujui, dan siap trading, Anda perlu menyelesaikan langkah-langkah berikut:</p> <ul><li>Unduh platform MT4</li> <li>Uji keterampilan trading Anda dan kecepatan eksekusi kami</li> <li>Masuk ke Portal Klien Anda dan tingkatkan ke akun live</li> <li>Unggah dokumen Anda dan lakukan deposit ke akun Anda</li> <li>Berdagang pasar keuangan terbesar di dunia!</li></ul> <p>Jika Anda memerlukan bantuan, tim layanan pelanggan kami yang ramah tersedia 24/5. Untuk menghubungi mereka, klik <a href="{contactURL}" target="_blank">di sini</a></p>',
  welcome_text_ib:
    '<p>Agar akun Mitra Anda disetujui dan siap menerima URL rujukan, Anda harus menyelesaikan langkah-langkah berikut:</p> <ul><li>Masuk ke Portal Klien Anda</li> <li>Unggah dokumen Anda</li> <li>Terima pelacakan URL Anda di bagian "ikhtisar" dan "alat pemasaran"</li> <li>Referensikan klien Anda dan dapatkan komisi!</li></ul> <p>Jika Anda memerlukan bantuan, tim layanan pelanggan kami yang ramah tersedia 24/5. Untuk menghubungi mereka, klik <a href="{contactURL}" target="_blank">di sini</a></p>',
  bankwire_passports_notice: 'PENTING: Paspor sebagai bukti ID diperlukan untuk melakukan wire transfer.',
  tracking_links: 'pelacakan tautan',
  proof_of_residence: 'bukti kependudukan',
  login_to_your_account: 'masuk ke<br> akun Anda',
  register: 'daftar',
  open_demo_account: 'buka akun demo',
  create_partner_account: 'buat partner akun',
  page_title_partner: 'Menjadi Partner | Eurotrader',
  ib_payout_msg_monthly_payment: 'Pembayaran dilakukan dua bulanan melalui metode pilihan Anda. Pembayaran akan dilakukan pada hari kerja ke-15 dan ke-1 setiap bulannya.',
  payout_selection_complete: 'Metode pembayaran telah dipilih.',
  home: 'rumah',
  about: 'tentang',
  account_types: 'jenis akun',
  spreads: 'spread',
  funding: 'pendanaan',
  education: 'edukasi',
  contact: 'kontak',
  forex_broker: 'broker forex',
  services_provided_by: 'Layanan keuangan yang disediakan oleh Eurotrade Global Ltd',
  footer_certificate_eurotrader:
    'Eurotrade SA (Pty) Ltd (“Eurotrader”) adalah anak perusahaan dari Eurotrade RGB Holdings Ltd (HE367109) dan merupakan penyedia layanan keuangan resmi, dilisensikan dan diatur oleh Financial Sector Conduct Authority (FSCA) di Afrika Selatan dengan nomor lisensi FSP <a href="https://www.fsca.co.za/Fais/Search_FSP.htm" style="color: #e04ef8; text-decoration: underline" target="_blank">44351</a> dengan alamat terdaftar di 74 Walmer street, Sydenham, Johannesburg, 2192, Afrika Selatan.<br><br><!-- \'Eurotrader\' adalah merek terdaftar dari Eurotrade Investments RGB Ltd, Perusahaan Investasi Siprus (CIF) dengan Nomor Pendaftaran HE317893, dilisensikan dan diatur oleh Komisi Sekuritas dan Pertukaran Siprus (CySEC) di bawah lisensi 279/15 dengan alamat terdaftar di 70, Kyrillou Loukareos Street, Kakos Premier Tower, Lantai 1, 4156 Limassol, Siprus. Pemrosesan kartu akan diselesaikan oleh Eurotrade Investments RGB Ltd.<br><br> -->Eurotrader tidak menyediakan layanan kepada penduduk yurisdiksi tertentu termasuk Amerika Serikat, Iran, Kanada, Republik Demokratik Korea, Belgia, Jepang, dan tidak dimaksudkan untuk didistribusikan ke, atau digunakan oleh, siapa pun di negara atau yurisdiksi mana pun di mana distribusi tersebut atau penggunaan akan bertentangan dengan hukum atau peraturan setempat.<br><br> Eurotrade SA (PTY) Ltd tidak secara aktif menargetkan klien UE.',
  footer_risk_warning:
    'Trading produk dengan leverage seperti Forex dan CFD mungkin tidak sesuai untuk semua investor karena membawa tingkat risiko terhadap modal Anda. Harap pastikan bahwa Anda sepenuhnya memahami risiko yang terlibat, dengan mempertimbangkan tujuan investasi dan tingkat pengalaman Anda, sebelum melakukan perdagangan, dan jika perlu mencari saran independen. <a href="https://eurotrader-com.s3.eu-west-2.amazonaws.com/legal-documents/Risk%20Disclosure.pdf" style="color: #e04ef8; text-decoration: underline" target="_blank">Harap baca Pengungkapan Risiko selengkapnya.</a>',
  open_live_account: 'buka live akun',
  not_registered_with_question: 'Tidak terdaftar di eurotrader?',
  forgot_password_q: 'lupa password Anda?',
  pending_deposit_success: 'Kegiatan berhasil, deposit Anda sekarang menunggu persetujuan',
  your_card_will_be_charged_cny: 'Kartu Anda akan dikenakan biaya <b>sebesar {amount}</b> CNY',
  currency_conversion_info: 'Info konversi mata uang',
  min_deposit_is_amount: 'Min. deposit adalah {jumlah}',
  min_transfer_is_amount: 'Min. transfer adalah {jumlah}',
  local_depositor: 'Lokal depositor',
  converted_amount: 'jumlah yang dikonversi',
  from_currency: 'dari mata uang',
  to_currency: 'ke mata uang',
  reference_id: 'referensi id',
  from_account: 'dari akun',
  to_account: 'ke akun',
  from_date: 'dari tanggal',
  to_date: 'sampai tanggal',
  target_account_id: 'target id akun',
  wallet: 'dompet',
  received: 'diterima',
  send: 'kirim',
  sender_not_a_transfer_account: 'pengirim bukan lokal depositor',
  withdrawal_failed_support: 'Penarikan tidak berhasil, harap hubungi layanan dukungan.',
  clear: 'jelas',
  transfer_completed_successfully: 'transfer berhasil diselesaikan',
  receive: 'menerima',
  view_trades: 'melihat perdagangan',
  your_provider_account_number: 'Nomor akun {provider} Anda',
  your_bitcoin_address: 'Alamat bitcoin Anda',
  your_crypto_address: 'Alamat {kripto} Anda',
  destination_tag: 'Tanda tujuan',
  change_trading_account_password: 'ubah kata sandi akun trading',
  your_card_will_be_charged_thb: 'Kartu Anda akan dikenakan biaya <b>{amount}</b> THB',
  dashboard: 'dasbor',
  sent: 'terkirim',
  client_state_approved: 'disetujui',
  client_state_pending: 'tertunda',
  client_state_incomplete: 'tidak lengkap',
  open_trades: 'perdagangan terbuka',
  trade_history: 'sejarah perdagangan',
  search_trades: 'pencarian perdagangan',
  trade_no: 'nomor perdagangan',
  symbol: 'simbol',
  open_price: 'open price',
  close_price: 'close price',
  datetime: 'tanggal Waktu',
  my_bonuses: 'bonus saya',
  bonus: 'bonus',
  conversion_progress: 'perkembangan konversi',
  front_of_id: 'KTP Depan',
  back_of_id: 'KTP Belakang',
  include_account_in_bonus_program: 'Saya ingin bergabung dengan Trading Program yang Didanai 111%.',
  invest_under_master_account: 'berinvestasi di akun master',
  i_accept_the_terms_of_service: 'saya menerima syarat dan ketentuan yang berlaku',
  pamm_master_locks_withdrawals: '[master pamm ini membatasi penarikan selama perdagangan terbuka!]',
  open_p_l: 'buka p&l',
  p_l: 'P&L',
  gains_prc: 'keuntungan %',
  max_drawdown: 'maks. drawdown',
  bonus_tos_with_link: 'Saya telah membaca dan memahami <a target="_blank" href="{URL}">syarat dan ketentuan Program Trading yang Didanai 111%</a>.',
  i_am_over_18: 'Saya menyatakan bahwa saya berusia di atas 18 (delapan belas) tahun untuk membuka Akun ini.',
  all_time: 'sepanjang waktu',
  last_month: 'bulan lalu',
  last_week: 'minggu lalu',
  last_3_days: '3 hari terakhir',
  monthly_avg: 'rata-rata bulanan',
  profit: 'profit',
  create_and_attach: 'buat dan lampirkan',
  attach: 'lampirkan',
  create_and_attach_new_pamm_account: 'buat dan lampirkan akun pamm baru',
  select_a_pamm_account_to_attach: 'pilih akun pamm untuk dilampirkan',
  enter_private_code: 'masukkan kode pribadi',
  private_code: 'kode pribadi',
  investor_link: 'Tautan Investor',
  i_accept_the_lpoa: 'saya menerima lpoa',
  invest: 'menginvestasikan',
  view_graph: 'lihat grafik',
  name: 'nama',
  search: 'pencarian',
  partners: 'partner',
  reject_withdrawls_during_open_trades: 'menolak penarikan selama perdagangan terbuka',
  private_master_account: 'akun master pribadi',
  minimum_deposit: 'minimum deposit',
  performance_fee: 'performance fee',
  display_name: 'tampilan nama',
  new_master_account: 'akun master baru',
  pamm_statistics: 'statistik pamm',
  pamm: 'pamm',
  volume_traded: 'volume yang diperdagangkan',
  apply_date_range: 'terapkan rentang tanggal',
  pamm_master_locks_deposits: '[master pamm ini membatasi deposit selama perdagangan terbuka!]',
  bitcoin: 'Bitcoin',
  register_live_account: 'daftar live akun',
  register_partner_account: 'daftar akun partner',
  register_demo_account: 'daftar akun demo',
  risk_disclosure: 'pengungkapan risiko',
  address_line_2: 'Alamat Baris 2',
  skype_id: 'skype id',
  password_rules_extended:
    'Kata sandi harus mengandung setidaknya: 1 huruf besar, 1 huruf kecil, 1 angka, dan satu karakter khusus. Panjang kata sandi harus antara 8 hingga 16 karakter.',
  login_information: 'informasi login',
  director: 'direktur',
  pmethod_visa_mastercard: 'VISA/MASTERCARD',
  pmethod_visa_mastercard_alternative: 'VISA/MASTERCARD.',
  pmethod_bitcoin: 'BITCOIN',
  pmethod_bankwire: 'Transfer uang antar bank',
  pmethod_fasapay: 'Fasapay',
  pmethod_ideal: 'ideal',
  pmethod_instant_bank_transfer: 'Transfer Bank Instan',
  pmethod_jeton: 'Jeton',
  pmethod_jeton_wallet: 'Jeton wallet',
  pmethod_my_pay: 'MyPay',
  pmethod_neteller: 'NETELLER',
  pmethod_vload: 'VLOAD',
  pmethod_paykasa: 'Paykasa',
  pmethod_skrill: 'Skrill',
  pmethod_sofort: 'Sofort',
  pmethod_koalapay: 'KoalaPay',
  pmethod_cup: 'CUP',
  pmethod_lydiax: 'Crypto',
  pmethod_safecharge: 'SafeCharge',
  pmethod_trustly: 'Trustly - Transfer Bank',
  pmethod_powercash: 'PowerCash',
  pmethod_astropay: 'AstroPay',
  pmethod_payneteasy: 'Payneteasy',
  field_min_currency_value: 'Bidang {field} harus {min} atau lebih.',
  method_deposit: 'deposit {metode}',
  method_deposit_status: '{method} status deposit',
  quick_menu: 'menu cepat',
  details: 'detail',
  date_from: 'dari tanggal',
  date_to: 'ke tanggal',
  from: 'dari',
  forgot_password_form_instruction: 'Kirimkan alamat email akun Anda di bawah ini. Anda akan menerima email dengan tautan untuk mengatur ulang kata sandi Anda.',
  forgot_password_submit_success_message:
    'Tautan pengaturan ulang password telah dikirim ke email Anda. Silakan buka email Anda ({email}) dan ikuti tautan untuk mengubah password Anda.',
  password_reset_successfully: 'Password Anda telah berhasil diatur ulang',
  password_too_week_or_mismatch: 'Password terlalu lemah atau entri kata sandi tidak cocok.',
  withdrawals_credit_card_remaining_amount_message: 'Untuk menarik melalui metode lain, Anda harus terlebih dahulu menarik {jumlah} kembali ke kartu kredit Anda.',
  withdrawals_credit_card_refund_policy_message: 'Penyedia Kartu Kredit hanya mengizinkan Anda untuk menarik jumlah total yang Anda setorkan kembali ke kartu Anda.',
  withdrawals_amount_withdrawable_message:
    'Sebanyak {jumlah} dapat ditarik kembali ke kartu Anda, apa pun yang melebihi jumlah tersebut dapat ditarik dengan salah satu metode kami yang lain.',
  country_blocked_for_this_method: 'Negara Anda diblokir untuk metode ini',
  copied_text_successfully: 'berhasil menyalin {teks}',
  choose_wallet_currency: 'pilih mata uang di dompet',
  pamm_master_account_created_successfully: 'Akun master PAMM berhasil dibuat!',
  or_account_no_for_uk: 'atau Nomor Akun (untuk Klien UK)',
  issue_date: 'Tanggal pembuatan',
  expiry_date: 'Tanggal kadaluarsa',
  full_copy_of_the_document: 'Salinan lengkap dokumen yang menunjukkan keempat sudutnya',
  recent_date: 'Tanggal terbaru (tidak lebih dari 3 bulan)',
  your_physical_address: 'Alamat fisik Anda, sesuai dengan alamat yang Anda gunakan saat mendaftar akun',
  must_be_a_utility_bill: 'Harus berupa Tagihan Utilitas (tagihan listrik, air, internet, telepon, gas/energi, pajak/sanitasi) atau Rekening koran',
  for_further_info_attach: '**Untuk dokumentasi lebih lanjut, harap lampirkan di email dan kirimkan ke backoffice@eurotrader.com',
  banners_ad_blocker_notice: 'Jika Anda kesulitan melihat spanduk di bawah ini, harap nonaktifkan pemblokir iklan Anda',
  content_ad_blocker_notice: 'Jika Anda kesulitan melihat klien web, harap nonaktifkan pemblokir iklan Anda',
  transfer_out: 'transfer keluar',
  transfer_in: 'transfer masuk',
  done: 'selesai',
  not_required: 'tidak dibutuhkan',
  wallet_balance: 'saldo dompet:',
  must_agree_terms: 'Anda harus menyetujui Syarat dan Ketentuan kami untuk membuat akun',
  select_payment_method: 'Pilih metode pembayaran',
  islamic_account: 'akun Islami',
  islamic_documents_instructions: 'Bukti keimanan/agama dari masjid',
  card_number: 'nomor kartu',
  expiry: 'Kedaluwarsa',
  redeem: 'menukarkan',
  must_be_multiple_of_10: 'Nilai harus kelipatan 10',
  select_starting_balance: 'Pilih saldo awal',
  business_name: 'Nama Bisnis',
  business_bank_wire_instructions: 'instruksi transfer bank bisnis',
  error_request_failed: 'Kesalahan: Permintaan gagal',
  error_no_user_with_this_email: 'Kesalahan: Akun dengan alamat email ini tidak ditemukan',
  error_too_many_password_reset_requests: 'Kesalahan: Terlalu banyak permintaan pengaturan ulang password',
  error_expired_or_invalid_request: 'Kesalahan: Permintaan tidak valid atau kedaluwarsa',
  error_insufficient_wallet_balance: 'Kesalahan: Saldo di dompet tidak mencukupi',
  error_insufficient_balance_or_equity: 'Kesalahan: Saldo atau ekuitas tidak mencukupi',
  error_pamm_master_deposit: 'Tidak dapat melakukan deposit di akun master PAMM',
  error_pamm_master_withdrawal: 'Tidak dapat melakukan penarikan dari akun master PAMM',
  error_pamm_master_locked_deposits: 'Ditolak: Master pamm dari akun tempat uang disimpan menolak deposit selama perdagangan terbuka.',
  error_pamm_master_locked_withdrawals: 'Ditolak: Master pamm dari akun tempat uang ditarik menolak penarikan selama perdagangan terbuka.',
  error_pamm_master_minimum_deposit: 'Ditolak: Persyaratan setoran minimum pamm master tidak terpenuhi.',
  error_live_account_already: 'Akun Anda sudah menjadi akun live',
  error_min_balance_required_is: 'Saldo minimum yang diperlukan untuk akun {TAAccountType} ({TAID}) adalah {min}{currency}.',
  error_transfer_same_wallet: 'Tidak dapat mentransfer dari dompet ke dompet.',
  error_transfer_same_trading_account: 'Tidak dapat mentransfer dari dan ke akun trading yang sama.',
  error_no_deposit_bonus_account_deposit_restricted: 'Deposit ke jenis akun "Bonus Tanpa Deposit" tidak diperbolehkan.',
  error_no_deposit_bonus_base_amount_withdrawal: 'Tidak dapat menarik nominal dasar "Bonus Tanpa Deposit".',
  error_no_deposit_bonus_withdraw_profit_requirement_not_met: 'Tidak dapat menarik "Bonus Tanpa Deposit" jika persyaratan keuntungan belum terpenuhi.',
  error_no_deposit_bonus_withdraw_exceeds_max_withdrawable_profit: 'Tidak dapat menarik lebih dari keuntungan maksimum yang dapat ditarik.',
  upgrade_required_for_live_ta: 'Akun klien Live dan Disetujui diperlukan sebelum akun trading live dapat dibuka!',
  error_wallet_currency_not_allowed_for_psp: 'Mata uang dompet tidak diizinkan untuk metode pembayaran ini.',
  error_invalid_or_expired_otp: 'Kesalahan: OTP yang diberikan tidak valid atau kedaluwarsa.',
  error_max_confirmo_withdrawal_exceeded: 'Kesalahan: Permintaan penarikan konfirmasi maksimum adalah 20000 EUR/USD',
  error_max_anual_vload_withdrawal_exceeded: 'Kesalahan: Jumlah total permintaan penarikan vload tahunan maksimum terlampaui',
  is_islamic_acc_message: 'Untuk membuat akun Islami, kirimkan permintaan ke backoffice@eurotrader.com untuk membantu Anda lebih lanjut.',
  error_invalid_voucher: 'Kesalahan: Voucher VLoad tidak valid atau sudah ditukarkan',
  error_blocked_voucher: 'Kesalahan: Voucher VLoad diblokir karena dugaan penipuan',
  error_voucher_data_mismatch: 'Kesalahan: Voucher VLoad ditolak karena ketidaksesuaian data akun.',
  error_vload_voucher_below_minimum: 'Kesalahan: Vload voucher di bawah jumlah setoran minimum.',
  my_bank_has_a_swift_code: 'Bank saya memiliki swift code',
  my_bank_does_not_have_a_swift_code: 'Bank saya tidak memiliki swift code',
  bank_not_in_swift_network_instructions: 'Jika bank Anda bukan anggota jaringan SWIFT, berikan detail Koresponden bank Anda berikut ini untuk menerima transfer Internasional:',
  correspondent_bank_name: 'Nama Bank Koresponden',
  correspondent_bank_city: 'Kota Bank Koresponden',
  correspondent_bank_swift: 'Swift Bank Koresponden',
  proof_of_cc: 'Bukti Kartu Kredit/Debit',
  front_of_cc: 'Bagian depan kartu',
  back_of_cc: 'Bagian belakang kartu',
  proof_of_cc_instructions: 'Harap unggah kartu kredit atau debit Anda.',
  add_document: 'Tambahkan dokumen (Opsional)',
  cc_requirements_1: 'Salinan dokumen lengkap yang menunjukkan keempat sudutnya.',
  cc_requirements_2:
    'Nama kartu: kartu yang akan Anda gunakan harus diterbitkan hanya atas nama Anda. Setiap deposit yang dilakukan dengan menggunakan kartu milik pihak ketiga, akan segera dikembalikan.',
  cc_requirements_3: 'Tanggal Kadaluarsa: tidak kurang dari 3 bulan.',
  cc_requirements_4: 'Nomor kartu: Delapan nomor tengah kartu harus ditutup dengan kertas. Hanya empat digit pertama dan empat digit terakhir yang akan terlihat.',
  cc_back_requirements_5: 'Kode CVV: Silakan gunakan kertas untuk menutupi kode CVV.',
  cc_back_requirements_6: 'Kartu harus ditandatangani.',
  click_to_add_another_document: 'Klik di atas untuk menambahkan slot upload dokumen lainnya',
  add_up_to_4_extra_documents: 'Anda dapat menambahkan hingga 4 dokumen tambahan',
  add_up_to_10_extra_documents: 'Anda dapat menambahkan hingga 10 dokumen tambahan',
  complete_profile: 'Profil Lengkap',
  document_received: 'Dokumen Anda telah diterima dan akan ditinjau oleh tim kami.',
  please_check_the_box: 'Harap centang kotak di bawah ini.',
  must_be_over_18: 'Anda harus berusia di atas 18 tahun untuk mendaftar.',
  shareholders_must_be_over_18: 'Pemegang saham harus berusia di atas 18 tahun untuk mendaftar.',
  directors_must_be_over_18: 'Direktur harus berusia di atas 18 tahun untuk mendaftar.',
  document_req_color: 'Dokumen harus berwarna',
  internal_error: 'Terjadi kesalahan internal..',
  please_enter_your_email: 'Masukkan alamat email Anda.',
  do_you_want_to_transform_your_trading: 'Apakah Anda ingin mengubah trading Anda?',
  reset_your_password_to_transfer_your_account: 'Atur ulang password Anda untuk mentransfer akun Anda.',
  reset_your_old_password: 'Atur ulang password lama Anda',
  reset_password_desc:
    'Karena transfer sistem, Anda diharuskan untuk memperbarui kata password Anda. Silakan gunakan formulir di bawah ini untuk menerima tautan atur ulang password.',
  eurotrader_login: 'Login Eurotrader | Masuk ke pusat perdagangan untuk meningkatkan trading Anda',
  your_email_is_verified: 'Email Anda sudah diverifikasi.',
  click_here_to_login: 'Klik di sini untuk masuk',
  success_email_verified: 'Sukses, email Anda sekarang sudah terverifikasi!',
  your_link_expired: 'Tautan Anda telah kedaluwarsa',
  click_here_to_request_verification_email: 'Klik di sini untuk meminta email verifikasi baru.',
  a_new_verification_link_send: 'Tautan verifikasi baru telah dikirim ke alamat email Anda.',
  invalid_request_please_check_your_link: 'Permintaan tidak valid. Periksa apakah tautan Anda sudah benar dan coba lagi.',
  invalid_verification_code: 'Kode verifikasi tidak benar',
  please_enter_amount: 'Silakan masukkan jumlah yang ingin Anda depositkan',
  bankwire_company_desc:
    '<p>Jika Anda adalah pemegang rekening bank bisnis dan Anda ingin menggunakan opsi transfer bank dengan mendaftarkan akun bisnis Anda dengan kami, kirimkan dokumentasi berikut melalui email ke backoffice@eurotrader.com</p> <ul><li>Akte perusahaan</li> <li>Sertifikat dari Direktur dan Sekretaris, jika ada</li> <li>Sertifikat Pemegang Saham Terdaftar/Pemilik Tunggal.</li> <li>Memorandum dan Anggaran Dasar, juga dikenal sebagai Anggaran</li> <li>Bukti Identifikasi dan Alamat untuk semua Pemegang Saham terdaftar, Pemilik Manfaat dan Direktur.</li> <li>Bukti domisili perusahaan.</li></ul> <p>Dokumen pemerintah/pejabat lainnya yang memverifikasi informasi yang diminta di atas dapat dianggap cukup, jika dokumen di atas tidak dapat diberikan dalam format tersebut.</p>',
  bankwire_noncompany_desc:
    '<p>Ini akan mengeluarkan Anda dari akun pribadi Anda dan mengarahkan Anda ke halaman pendaftaran kami untuk akun Perusahaan.</p> <p>Apakah Anda ingin melanjutkan?</p>',
  please_enter_card_detail_and_amount: 'HARAP MASUKKAN DETAIL KARTU DAN JUMLAH YANG INGIN ANDA DEPOSITKAN',
  important: 'PENTING',
  please_note_that_the_maximum_deposit_amount: 'Harap diperhatikan bahwa jumlah deposit maksimum per hari adalah $1000 per kartu.',
  city: 'Kota',
  zip: 'Kode pos',
  please_note_that_after_three_unsuccessful_attempts:
    '* Harap diperhatikan bahwa setelah tiga (3) upaya yang gagal, opsi pembayaran VISA/MASTERCARD tidak akan tersedia selama 24 jam.',
  epay_pro_desc:
    '<p>Pedagang yang terhormat<br><br> Sayangnya, karena masalah teknis dan batasan tertentu, Deposit Kartu Kredit akan dinonaktifkan sementara melalui penyedia kami EPayPro.<br><br> Visa &amp; Mastercard akan dinonaktifkan pada tengah malam 23:00 GMT 04/04/2018. Setelah penyedia pembayaran dinonaktifkan, deposit akan dinonaktifkan sementara. Meskipun penyedia pembayaran kami belum memberi kami kerangka waktu yang tepat untuk waktu henti, kami berupaya menerapkan alternatif sesegera mungkin.<br><br> Kami bekerja sama dengan penyedia kami untuk menyelesaikan masalah saat ini sehingga di masa mendatang, akun dapat melanjutkan pemrosesan setoran tanpa penundaan.<br><br> Jangan ragu untuk menghubungi tim layanan pelanggan kami jika ada pertanyaan lebih lanjut.</p>',
  provider_redirect: 'Anda akan dialihkan ke {provider}.',
  lydiax_note: 'Setoran minimum adalah 30 EUR/USD',
  lydiax_note1:
    'Jika Anda menyetor {crypto} senilai kurang dari 30 EUR/USD, Anda harus mengirim email ke backoffice@eurotrader.com, dan meminta pengembalian dana, memberikan alamat {crypto} yang ingin Anda gunakan untuk menerima pengembalian dana.',
  lydiax_note2:
    'Silahkan masukkan jumlah {crypto} yang ingin Anda setorkan untuk melihat perkiraan apa yang akan Anda dapatkan. Perlu diingat bahwa harga berikut ini hanya berlaku saat diminta dan dapat berubah sewaktu-waktu.',
  lydiax_note3: 'Kami akan membuat alamat deposit untuk Anda gunakan.',
  lydiax_note4: 'Harap gunakan alamat berikut untuk deposit {crypto}.',
  lydiax_note5: 'Selanjutnya, alamat unik ini akan digunakan untuk deposit Anda di {crypto}.',
  lydiax_required_address: 'Jika dompet Anda memerlukan alamat dan tanda secara terpisah, gunakan:',
  tag: 'Menandai',
  lydiax_enter_deposit: 'HARAP MASUKKAN CRYPTOCURRENCY YANG INGIN ANDA DEPOSITKAN',
  create_address: 'Buat alamat',
  please_note: 'Tolong dicatat:',
  price_estimate: 'Estimasi harga:',
  check_price: 'Cek harga',
  vload_please_enter_voucher: 'HARAP MASUKKAN NOMOR PIN VOUCHER VLOAD ANDA',
  vload_minimum: '<p>(Nilai voucher minimum yang dapat diterima adalah <b>50</b> EUR atau USD!)</p>',
  vload_vouchers: 'Saya perlu membeli VLoad Voucher',
  vload_note:
    'Lakukan pembayaran tanpa kerumitan dengan Visa/MasterCard serta Transfer Bank lokal.<br> Pelajari lebih lanjut tentang VLoad atau beli voucher [EUR / USD] di vload.expert.',
  vload_note1: 'Agar dapat menyetor dengan VLoad, akun Anda harus disetujui terlebih dahulu!',
  reason: 'Alasan:',
  attempts: 'Percobaan {attempts} dari {maxAttempts},',
  two_more_remaining: 'tersisa 2 (dua) buah lagi',
  one_more_remaining: 'Hanya SATU (1) percobaan yang tersisa',
  please_contact_bank: '<br>Silakan hubungi bank penerbit kartu.<br> Kartu Anda mungkin diblokir untuk transaksi di luar negeri',
  edata_success_note:
    'Harap dicatat bahwa mungkin ada biaya tambahan pada deposit Anda, yang dibebankan oleh bank penerbit Anda karena transaksi internasional. Biaya ini akan menjadi biaya yang kecil, tetapi akan bervariasi dari satu bank ke bank lainnya. <br><br>Transaksi kartu kredit ini akan muncul di laporan mutasi Anda sebagai “Tech Savvy Billing", “Business Billing“ atau “Business media Billing“.',
  you_can_try: 'Anda dapat mencoba lagi',
  here: 'di sini',
  safe_charged_success_message: 'Deposit Anda akan diproses oleh backoffice kami dalam waktu 2 hari kerja.',
  thank_you: 'Terima kasih!',
  your_deposit_successful: 'Deposit Anda berhasil',
  card_redirect: 'Anda akan diarahkan untuk memasukkan kartu kredit dan detail pribadi Anda.',
  bank_wire_withdrawal_note:
    'Dalam hal penolakan Transfer Bank atas nama bank penerima karena detail bank yang salah diberikan oleh klien, berbagai biaya administrasi transfer bank yang dibebankan oleh bank yang terlibat akan dikurangi dari jumlah penarikan yang diminta sebelum mengkredit dompet klien .',
  please_enter_amount_withdraw: 'Silakan masukkan jumlah yang ingin Anda tarik',
  bitcoin_note: 'Silakan masukkan alamat bitcoin Anda dan jumlah yang ingin Anda tarik',
  otp: 'Password Sekali Pakai (OTP)',
  otp_send_email: 'Kirim OTP ke Email',
  otp_additional_text: 'OTP di atas adalah untuk permintaan penarikan Bitcoin saat ini yang Anda buat',
  otp_new_password: 'Password satu kali (OTP) baru telah dikirim ke email Anda',
  otp_error: 'Kesalahan - Gagal mengirim OTP',
  lydiax_withdrawal_note:
    'Masukkan jumlah {currency} yang ingin Anda tarik untuk melihat perkiraan {crypto} yang akan Anda dapatkan. Perlu diingat bahwa harga berikut ini hanya berlaku saat diminta dan dapat berubah sewaktu-waktu.',
  enter_currency_amount: 'Masukkan jumlah {currency} untuk memeriksa perkiraan',
  lydiax_withdrawal_additional_note: 'OTP di atas adalah untuk permintaan penarikan Crypto yang Anda buat saat ini',
  estimated: 'Diperkirakan:',
  please_enter_your_crypto_address: 'Harap masukkan alamat {crypto} Anda dan jumlah yang ingin Anda tarik',
  select_cryptocurrency: 'Pilih mata uang kripto',
  request_amount: 'Jumlah yang diminta',
  amount_changes: 'Jumlah yang Dibebankan (termasuk biaya)',
  operation_failed: 'Operasi gagal! Permintaan Anda tidak valid.',
  operation_failed_error: 'Operasi gagal! Terjadi kesalahan saat memproses permintaan ini.',
  are_you_sure_create_master: 'Apakah Anda yakin ingin membuat akun baru dan melampirkannya di bawah master ini?',
  are_you_sure_attach_selected_account_to_master: 'Apakah Anda yakin ingin melampirkan akun yang dipilih ke master ini?',
  change_password_desc:
    '<strong>*</strong> Perubahan kata sandi ini tidak akan memengaruhi kata sandi akun trading Anda. Silakan kunjungi <strong>daftar akun</strong> untuk mengubah kata sandi akun perdagangan Anda, menggunakan opsi <strong>ubah kata sandi</strong> di bawah ikon roda gigi.',
  client_assessment: 'PENILAIAN KLIEN',
  select_answer: 'Pilih jawaban...',
  declarations: 'DEKLARASI',
  complele_profile_desc:
    'Apakah Anda saat ini, atau apakah Anda pernah terlibat dalam kegiatan kriminal atau apakah ada tuntutan pidana terhadap Anda yang tertunda di pengadilan?',
  complete_profile_desc1:
    'Apakah Anda atau kerabat atau rekan dekat Anda adalah Orang yang Terekspos Secara Politik? Politically Exposed Persons adalah orang perseorangan yang sedang atau telah dipercayakan dengan fungsi publik terkemuka dalam 12 bulan terakhir, yaitu Kepala Negara atau pemerintahan, politisi senior, pemerintahan senior, pejabat yudisial atau militer, eksekutif senior perusahaan milik negara, pejabat penting pejabat partai politik.',
  are_you_us_citizen: 'Apakah Anda warga negara AS atau penduduk AS untuk keperluan pajak?',
  please_check_forms_errors: 'Harap periksa formulir untuk kesalahan!',
  profile_succesfully_completed: 'Profil berhasil diselesaikan',
  please_select_country: 'Silakan pilih Negara Anda',
  set_country: 'Tetapkan negara',
  empty_country_code: 'Kode negara kosong, lakukan penyegaran halaman dan coba lagi.',
  invalid_country_code: 'Kode negara tidak valid, lakukan penyegaran halaman dan coba lagi.',
  individual_company: 'APAKAH ANDA INDIVIDU ATAU PERUSAHAAN?',
  prev: 'SEBELUM',
  previous: 'SEBELUMNYA',
  complete: 'MENYELESAIKAN',
  please_select_an_option: 'Harap pilih opsi untuk setiap bidang!',
  swap: 'swap',
  buy: 'buy',
  sell: 'sell',
  sums: 'jumlah',
  net_total: 'JUMLAH BERSIH',
  deposit_page_desc:
    '<p class="has-text-white is-size-5-desktop is-size-6-tablet is-size-6-mobile has-text-weight-bold">Daftar sekarang dan</p> <p class="is-size-1-desktop is-size-2-tablet is-size-3-mobile has-text-weight-bold vload-promo-large-text">Dapatkan <span class="has-text-white has-text-weight-bold">GRATIS</span><br> 10 EUR/USD<br> eVoucher</p>',
  deposit_page_desc1: 'eVoucher Bonus 10 EUR/USD akan diaktifkan setelah Anda',
  create_new_account: 'Buat akun baru',
  successfully_purchase_vload: 'berhasil membeli dan menukarkan eVoucher VLoad dengan nilai berapa pun',
  upgrade_to_tier_2: 'Tingkatkan ke tingkat 2',
  register_now: 'DAFTAR SEKARANG',
  back: 'KEMBALI',
  my_card_desc: 'Di sini Anda dapat melihat semua kartu yang Anda gunakan untuk pembayaran dan statusnya saat ini di sistem kami.',
  you_have_no_card: 'Anda belum melakukan deposit kartu.',
  card_no: 'Nomor kartu.',
  last_used: 'Terakhir digunakan',
  risk_warning: 'PERINGATAN RISIKO',
  upload_documents_note: 'Jika Anda ingin melakukan deposit Kartu, berikan tambahan dokumen berikut untuk diperiksa dan disetujui.',
  please_select_your_country: 'Silakan pilih negara Anda terlebih dahulu',
  add_another_document: 'Tambahkan dokumen lain',
  drop_files_upload: 'Taruh file di sini untuk upload',
  date_until: 'Berlaku hingga',
  copy: 'Salinan',
  cvv: 'CVV',
  please_enter_crypto_amount: 'Masukkan jumlah {kripto}',
  vload_pin: 'Pin VLoad',
  deposit_info:
    'Penyedia pembayaran saat ini mengalami masalah teknis dan setoran langsung Visa/Mastercard saat ini tidak tersedia. Sebagai alternatif, jika Anda ingin menyetor menggunakan Visa/Mastercard, Anda dapat menggunakan opsi `Vload`',
  id: 'IDENTITAS',
  pamm_modal_error: 'Data yang dimasukkan tidak valid untuk Nama Tampilan. Jangan biarkan kosong atau masukkan lebih dari 32 karakter',
  pamm_modal_error1: 'Nilai yang dimasukkan untuk Setoran Minimum tidak valid. Masukkan bilangan bulat positif di bawah 1.000.000.',
  error_missing_required_field: 'Kesalahan, kolom wajib diisi tidak ada',
  page_not_found: 'HALAMAN TIDAK DITEMUKAN',
  new_version_note: 'VERSI BARU TERDETEKSI, SILAHKAN KLIK DI SINI UNTUK MENYEGARKAN',
  new_version_note1: 'Beberapa fungsi mungkin tidak tersedia hingga Anda menyegarkan halaman',
  records: 'Catatan',
  gateway: 'gateaway',
  account_no: 'No rekening.',
  routing_no: 'Routing No.',
  train_up: 'BERLATIH.',
  trade_up: 'PERDAGANGAN.',
  train_text_1: 'Siap berinvestasi untuk diri Anda di masa depan?',
  train_text_2: 'Mulailah dengan akun demo bebas risiko dan akses ke sumber belajar Eurotrader Academy.',
  train_list_item_1: 'Praktek trading di lingkungan simulasi.',
  train_list_item_2: 'Dapatkan akses ke sumber belajar terbaik di kelasnya.',
  train_list_item_3: 'Menjadi bagian dari komunitas Eurotrader.',
  train_list_item_4: 'Ingat: tidak ada yang dirugikan, semuanya untung.',
  form_title_1: 'LAKUKAN PRAKTEK MU',
  form_title_2: 'DENGAN',
  form_title_3: 'Akun Demo',
  form_subtitle: 'Dan mendapatkan akses ke sumber belajar',
  region: 'Wilayah',
  wallet_currency: 'Mata Uang Dompet',
  select_currency_label: 'Mata uang akun demo Anda',
  join: 'Ikuti',
  demo_account: 'Akun Demo',
  page_title_demo: 'Buka akun demo | Eurotrader',
  title_404: 'HAI UANG, SAYA RUMAH!',
  text_line_1_404: 'Apa? Tidak ada seorang pun di sini untuk membantu Anda berinvestasi dalam diri Anda di masa depan?',
  text_line_2_404: 'Ayo kembali ke rumah dan tunjukkan uang Anda terbuat dari apa.',
  button_404: 'KEMBALI',
  remember_me: 'Ingat saya',
  risk_sentence: 'Untuk melihat bagaimana kami menggunakan data Anda, silahkan tinjau',
  video_courses: 'Kursus Video kami',
  ebooks: 'E-Books',
  knowledge_and_experience: 'PENGETAHUAN DAN PENGALAMAN',
  economic_profile: 'PROFIL EKONOMI',
  product_governance: 'TATA KELOLA PRODUK',
  select_an_answer: 'Pilih jawaban',
  declarations_q1: 'Apakah Anda saat ini, atau apakah Anda pernah terlibat dalam kegiatan kriminal atau apakah ada tuntutan pidana terhadap Anda yang tertunda di pengadilan?',
  declarations_q2:
    'Apakah Anda atau kerabat atau rekan dekat Anda adalah Orang yang Terekspos Secara Politik? Politically Exposed Persons adalah orang perseorangan yang sedang atau telah dipercayakan dengan fungsi publik terkemuka dalam 12 bulan terakhir, yaitu Kepala Negara atau pemerintahan, politisi senior, pemerintahan senior, pejabat yudisial atau militer, eksekutif senior perusahaan milik negara, pejabat penting pejabat partai politik.',
  declarations_q3: 'Apakah Anda warga negara AS atau penduduk AS untuk keperluan pajak?',
  ca_q1: '1. Apakah Anda memiliki Pengalaman dalam trading?',
  ca_q2: '2. Sudah berapa lama Anda berinvestasi/trading di pasar keuangan?',
  ca_q3: '3. Berapa banyak transaksi yang telah Anda lakukan dalam dua tahun terakhir?<br> sebuah. Ekuitas dan Pendapatan Tetap (Saham &amp; Obligasi)',
  ca_q4: '&nbsp;&nbsp; b. Forex',
  ca_q5: '&nbsp;&nbsp; c. CFD (Contracts for Differences)',
  ca_q6: '&nbsp;&nbsp; d. Produk Derivatif Lainnya (Warrants, Options, Rights)',
  ca_q7: '4. Berapa jumlah rata-rata (setiap bulan) yang telah Anda investasikan ke kategori berikut?<br> sebuah. Ekuitas dan Pendapatan Tetap (Saham &amp; Obligasi)',
  ca_q8: '&nbsp;&nbsp; b. Forex',
  ca_q9: '&nbsp;&nbsp; c. CFD (Contracts for Differences)',
  ca_q10: '&nbsp;&nbsp; d. Produk Derivatif Lainnya (Warrants, Options, Rights)',
  ca_q11: '5. Jenis layanan investasi apa yang sudah Anda gunakan? (berisi beberapa jawaban)',
  ca_q12: '6. Apakah salah satu dari hal di bawah ini berlaku untuk Anda? (berisi beberapa jawaban)',
  ca_q13:
    '7. Saham Apple diperdagangkan dengan harga jual $204 dan harga beli $206. Anda membeli 100 saham Apple dengan harga yang disebutkan di atas. Berapa keuntungan/kerugian yang terjadi pada akun Anda jika harga saham Apple bergerak pada harga jual $190 dan harga beli $192 dan Anda menutup posisi Anda?',
  ca_q14:
    '8. Apple Share diperdagangkan dengan harga jual $204 dan harga beli $206. Anda membuka perdagangan CFD beli (beli) untuk 100 kontrak (setiap kontrak menggarisbawahi 1 saham Apple). Leverage yang digunakan adalah 1:5. Berapa keuntungan/kerugian yang terjadi pada akun Anda jika harga saham Apple bergerak pada harga jual $190 dan harga beli $192 dan Anda menutup posisi Anda?',
  ca_q15: '9. Menggunakan stop loss order:',
  ca_q16: '10. Saldo akun Anda rendah. Pada kesempatan manakah Anda mungkin diminta untuk menambahkan dana ke akun Anda?',
  ca_q17:
    '11. Indeks S&P 500 memiliki harga beli $2700. Anda memutuskan untuk membuka perdagangan CFD long (beli) dari 2 kontrak. Leverage yang digunakan adalah 1:20. Anda menetapkan stop loss pada harga $2600 dan take profit pada harga $3000. Dengan asumsi saldo di akun Anda cukup dan pesanan tidak berubah sampai harga jual stop loss atau harga jual take profit tercapai dan tidak ada biaya tambahan yang dikeluarkan, berapa keuntungan atau kerugian yang akan Anda alami di akun Anda saat posisi ditutup?',
  ca_q18: '1. Berapa total pendapatan tahunan Anda?',
  ca_q19: '2. Apa sumber penghasilan Anda?',
  ca_q20: '3. Berapa persentase pendapatan tahunan Anda terkait dengan kewajiban keuangan?',
  ca_q21: '4. Berapa perkiraan nilai Aset Anda?',
  ca_q22: '5. Bagaimana struktur Aset Anda?',
  ca_q23: '6. Berapa perkiraan Kekayaan Bersih Anda (Total Aset – Total Kewajiban)?',
  ca_q24: '1. Silakan pilih salah satu dari pernyataan di bawah ini:',
  ca_q25: '2. Manakah dari pernyataan berikut yang lebih tepat untuk Anda?',
  ca_q26: '3. Mana yang paling relevan dengan gaya investasi Anda?',
  ca_q27: '4. Berdasarkan ekspektasi Anda, berapa fluktuasi tahunan dari nilai portofolio Anda yang bersedia Anda terima?',
  ca_q28: '5. Manakah dari opsi berikut yang akan dianggap sebagai portofolio yang paling sesuai untuk Anda?',
  ca_q29: '6. Bagaimana jangka waktu tujuan investasi Anda?',
  ca_q30: '7. Apa tujuan investasi Anda?',
  ca_q31: '8. Berapa tingkat likuiditas portofolio Anda yang bersedia Anda terima?',
  ca_q1_ao1: 'a) Ya, saya telah berdagang di akun real',
  ca_q1_ao2: 'b) Ya, saya telah berdagang di akun demo',
  ca_q1_ao3: 'c) Tidak, tetapi saya telah menggunakan layanan investasi Portfolio Management dan/atau Investment Advice',
  ca_q1_ao4: 'd) Tidak, tetapi saya memiliki pengetahuan yang luas melalui pendidikan saya (sarjana, magister, dll.)',
  ca_q1_ao5: 'e) Tidak',
  ca_q2_ao6: 'a) 0 - 6 bulan',
  ca_q2_ao7: 'b) 6 - 12 bulan',
  ca_q2_ao8: 'c) 1 - 2 tahun',
  ca_q2_ao9: 'd) 2 - 4 tahun',
  ca_q2_ao10: 'e) Lebih dari 4 tahun',
  ca_q3_ao11: 'I. Tidak pernah',
  ca_q3_ao12: 'II. Jarang (kurang dari 50 kali)',
  ca_q3_ao13: 'III. Kadang-kadang (50-100 kali)',
  ca_q3_ao14: 'IV. Sering (lebih dari 101 perdagangan)',
  ca_q4_ao15: 'I. Tidak pernah',
  ca_q4_ao16: 'II. Jarang (kurang dari 50 kali)',
  ca_q4_ao17: 'III. Kadang-kadang (50-100 kali)',
  ca_q4_ao18: 'IV. Sering (lebih dari 101 perdagangan)',
  ca_q5_ao19: 'I. Tidak pernah',
  ca_q5_ao20: 'II. Jarang (kurang dari 50 kali)',
  ca_q5_ao21: 'III. Kadang-kadang (50-100 kali)',
  ca_q5_ao22: 'IV. Sering (lebih dari 101 perdagangan)',
  ca_q6_ao23: 'I. Tidak pernah',
  ca_q6_ao24: 'II. Jarang (kurang dari 50 kali)',
  ca_q6_ao25: 'III. Kadang-kadang (50-100 kali)',
  ca_q6_ao26: 'IV. Sering (lebih dari 101 perdagangan)',
  ca_q7_ao27: 'i. 0',
  ca_q7_ao28: 'ii. Kurang dari €500',
  ca_q7_ao29: 'iii. €501 - €2.000',
  ca_q7_ao30: 'iv. €2.001 - €5.000',
  ca_q7_ao31: 'v. Lebih dari €5.001',
  ca_q8_ao32: 'saya. 0',
  ca_q8_ao33: 'ii. Kurang dari €500',
  ca_q8_ao34: 'iii. €501 - €2.000',
  ca_q8_ao35: 'iv. €2.001 - €5.000',
  ca_q8_ao36: 'v. Lebih dari €5.001',
  ca_q9_ao37: 'i. 0',
  ca_q9_ao38: 'ii. Kurang dari €500',
  ca_q9_ao39: 'iii. €501 - €2.000',
  ca_q9_ao40: 'iv. €2.001 - €5.000',
  ca_q9_ao41: 'v. Lebih dari €5.001',
  ca_q10_ao42: 'i. 0',
  ca_q10_ao43: 'ii. Kurang dari €500',
  ca_q10_ao44: 'iii. €501 - €2.000',
  ca_q10_ao45: 'iv. €2.001 - €5.000',
  ca_q10_ao46: 'v. Lebih dari €5.001',
  ca_q11_ao47: 'a. Penerimaan dan transmisi dan/atau eksekusi order (layanan investasi yang memerlukan keputusan independen)',
  ca_q11_ao48: 'b. Saran investasi',
  ca_q11_ao49: 'c. Manajemen portofolio',
  ca_q11_ao50: 'd. Tidak ada',
  ca_q12_ao51: 'a. Saya memiliki pengalaman profesional yang relevan',
  ca_q12_ao52: 'b. Saya secara teratur memantau berita/pasar',
  ca_q12_ao53: 'c. Saya pernah mengikuti seminar atau kursus yang berhubungan dengan Financial Markets/Investasi/Online Trading',
  ca_q12_ao54: 'd. Bukan dari salah satu di atas',
  ca_q13_ao55: 'a. -€1.200',
  ca_q13_ao56: 'b. -€1.400',
  ca_q13_ao57: 'c. -€1.600',
  ca_q13_ao58: 'd. -€1.800',
  ca_q14_ao59: 'a. -€6.000',
  ca_q14_ao60: 'b. -€7.000',
  ca_q14_ao61: 'c. -€8.000',
  ca_q14_ao62: 'd. -€10.000',
  ca_q15_ao63: 'a. Melindungi Anda dari kerugian yang cepat',
  ca_q15_ao64: 'b. Batasi paparan risiko Anda',
  ca_q15_ao65: 'c. Memastikan Anda tidak pernah membuat kerugian pada perdagangan',
  ca_q15_ao66: 'd. Melindungi Anda dari risiko penggunaan leverage',
  ca_q16_ao67: 'a. Jika harga yang mendasari posisi terbuka bergerak melawan Anda agar ekuitas Anda bergerak di bawah margin pemeliharaan minimum Anda.',
  ca_q16_ao68: 'b. Jika Anda dikenakan biaya transaksi yang membuat akun Anda mengalami defisit.',
  ca_q16_ao69: 'c. Jika posisi CFD terbuka menimbulkan biaya semalam yang membuat akun Anda mengalami defisit.',
  ca_q16_ao70: 'd. Semua yang di atas.',
  ca_q17_ao71: 'a. -$100 atau $300',
  ca_q17_ao72: 'b. -$200 atau $600',
  ca_q17_ao73: 'c. - $2.000 atau $6.000',
  ca_q17_ao74: 'd. - $4.000 atau $12.000',
  ca_q18_ao75: 'a. Kurang dari €20.000',
  ca_q18_ao76: 'b. Antara €20.000 dan €50.000',
  ca_q18_ao77: 'c. Antara €50.000 dan €100.000',
  ca_q18_ao78: 'd. Lebih dari €100.000',
  ca_q19_ao79: 'a. Gaji/ Pensiun',
  ca_q19_ao80: 'b. Dividen/ Bunga/ Kupon',
  ca_q19_ao81: 'c. Sewa',
  ca_q19_ao82: 'd. Donasi/Warisan',
  ca_q19_ao83: 'e. Sumber penghasilan lainnya',
  ca_q20_ao84: 'a. Kurang dari 25%',
  ca_q20_ao85: 'b. Antara 25% dan 50%',
  ca_q20_ao86: 'c. Antara 50% dan 75%',
  ca_q20_ao87: 'd. Lebih dari 75%',
  ca_q21_ao88: 'a. Kurang dari €100.000',
  ca_q21_ao89: 'b. Antara €100.000 dan €500.000',
  ca_q21_ao90: 'c. Antara €500.000 dan €1.000.000',
  ca_q21_ao91: 'd. Lebih dari €1.000.000',
  ca_q22_ao92: 'a. Terutama di deposito Bank',
  ca_q22_ao93: 'b. Terutama di Real estat',
  ca_q22_ao94: 'c. Terutama di Instrumen Keuangan',
  ca_q22_ao95: 'd. Dialokasikan secara merata di ketiga opsi di atas',
  ca_q22_ao96: 'e. Lainnya',
  ca_q23_ao97: 'a. Kurang dari €100.000',
  ca_q23_ao98: 'b. Antara €100.000 dan €500.000',
  ca_q23_ao99: 'c. Antara €500.000 dan €1.000.000',
  ca_q23_ao100: 'd. Lebih dari €1.000.000',
  ca_q24_ao101: 'a. Saya hanya mengambil risiko yang dapat mengurangi modal yang saya investasikan dalam keadaan ekstrim.',
  ca_q24_ao102: 'b. Saya dapat mempertaruhkan sebagian dari modal yang saya investasikan untuk mencapai pengembalian yang lebih tinggi dari rata-rata.',
  ca_q24_ao103: 'c. Saya dapat mempertaruhkan sebagian atau seluruh modal yang saya investasikan, dengan harapan saya akan mendapatkan pengembalian yang lebih tinggi.',
  ca_q25_ao104: 'a. Yang paling penting bagi saya adalah keamanan modal saya. Jadi, untuk menghindari kerugian apa pun, saya siap menyerahkan pengembalian yang lebih tinggi',
  ca_q25_ao105:
    'b. Untuk mendapatkan pengembalian yang lebih tinggi dari rata-rata, saya menerima pengambilan risiko yang lebih tinggi dan saya siap menerima sedikit penurunan modal saya.',
  ca_q25_ao106: 'c. Untuk keuntungan yang tinggi saya siap untuk mengambil resiko yang tinggi bahkan jika sebagian atau seluruh modal saya beresiko.',
  ca_q26_ao107: 'a. Pelestarian modal',
  ca_q26_ao108: 'b. Pertumbuhan pendapatan',
  ca_q26_ao109: 'c. Spekulasi',
  ca_q26_ao110: 'd. Hedging',
  ca_q27_ao111: 'a. ± 5%',
  ca_q27_ao112: 'b. ± 10%',
  ca_q27_ao113: 'c. ± 25%',
  ca_q27_ao114: 'd. ± 50%',
  ca_q28_ao115: 'a. Yang akan menghasilkan pengembalian 1 - 2% yang stabil di tahun-tahun mendatang.',
  ca_q28_ao116: 'b. Yang akan menghasilkan pengembalian antara -2% dan +10% di tahun-tahun berikutnya.',
  ca_q28_ao117:
    'c. Yang diharapkan menghasilkan pengembalian antara -15% dan +30% di tahun depan dan bahkan dapat menyebabkan kerugian melebihi jumlah yang diinvestasikan dalam kondisi ekstrem.',
  ca_q29_ao118: 'a. Hingga 1 tahun',
  ca_q29_ao119: 'b. Antara 1 dan 3 tahun',
  ca_q29_ao120: 'c. Antara 3 dan 5 tahun',
  ca_q29_ao121: 'd. Lebih dari 5 tahun',
  ca_q30_ao122: 'a. Manajemen likuiditas jangka pendek untuk menutupi biaya tak terduga.',
  ca_q30_ao123: 'b. Penghematan jangka panjang.',
  ca_q30_ao124: 'c. Hasilkan keuntungan tinggi bahkan dengan risiko kehilangan jumlah yang diinvestasikan',
  ca_q31_ao125: 'a. Kurang dari 25%',
  ca_q31_ao126: 'b. Antara 25% dan 50%',
  ca_q31_ao127: 'c. Antara 50% dan 75%',
  ca_q31_ao128: 'd. Lebih dari 75%',
  passport_ple_different: 'Jika negara tempat tinggal Anda dan negara penerbit ID Anda berbeda, harap unggah Paspor Anda.',
  live_account: 'Akun Live',
  agree_terms_marketing: 'Saya setuju untuk menerima update pemasaran dari Eurotrader (lihat <a href="{PRIVACY_URL}" target="_blank">Kebijakan Privasi</a> ).',
  data_policy_text:
    'Data Anda aman bersama kami, dan Anda dapat berhenti berlangganan kapan saja. Dengan mengeklik di bawah ini, Anda mengonfirmasikan bahwa Anda telah membaca dan menerima <a href="{TERMS_CONDITIONS_URL}" target="_blank">S&amp;K</a> dan <a href="{RISK_DISCLOSURE_URL}" target="_blank">pengungkapan risiko</a> dan Anda menyetujui kami menyimpan dan memproses informasi pribadi Anda.',
  live_tos_with_link: 'Saya telah membaca, memahami, dan menerima syarat dan ketentuan serta pengungkapan peringatan risiko <a href="{URL}" target="_blank">di sini</a> .',
  must_agree_marketing_terms: 'Silakan centang kotak untuk melanjutkan ke langkah berikutnya',
  tick_checkboxes: 'Harap centang kotak untuk melanjutkan',
  partner_account: 'Akun Partner',
  privacy_policy: 'Kebijakan pribadi',
  client: 'klien',
  commission_amount: 'jumlah komisi',
  tier_name: 'nama tingkatan',
  trades_completed: 'perdagangan selesai',
  trade: 'berdagang',
  pamm_investor_selection_note:
    "* Harap dicatat 'Akun investor' secara khusus dirancang untuk digunakan sehubungan dengan akun Master dan tidak dapat diperdagangkan secara manual. Silakan hubungi dukungan pelanggan jika Anda ingin mengetahui lebih banyak tentang akun investor",
  bitpace_network_warning_BTC: 'Alamat ini hanya untuk deposit Bitcoin. Jangan kirim dari rantai apa pun selain BTC atau setoran Anda mungkin hilang',
  bitpace_network_warning_LTC: 'Alamat ini hanya untuk deposit Litecoin. Jangan mengirim dari rantai apa pun selain LTC atau setoran Anda mungkin hilang',
  bitpace_network_warning_XRP: 'Alamat ini hanya untuk deposit Ripple. Jangan mengirim dari rantai apa pun selain XRP atau deposit Anda mungkin hilang',
  bitpace_network_warning_BCH: 'Alamat ini hanya untuk deposit Bitcoin Cash. Jangan kirim dari rantai apa pun selain BCH atau deposit Anda mungkin hilang',
  bitpace_network_warning_USDT:
    'Silakan gunakan jaringan Ethereum (ERC20) atau TRON (TRC20) saja. Deposit Anda akan hilang dan tidak dapat dipulihkan jika Anda tidak menggunakan jaringan yang ditentukan. Harap jangan mengirim dana melalui BSC, BEP20, BEP-2 atau jaringan lainnya.',
  bitpace_network_warning_USDC:
    'Silakan gunakan jaringan Ethereum (ERC20) atau TRON (TRC20) saja. Deposit Anda akan hilang dan tidak dapat dipulihkan jika Anda tidak menggunakan jaringan yang ditentukan. Harap jangan mengirim dana melalui BSC, BEP20, BEP-2 atau jaringan lainnya.',
  bitpace_network_warning_TRX:
    'Harap gunakan jaringan TRON (TRC20) saja. Deposit Anda akan hilang dan tidak dapat dipulihkan jika Anda tidak menggunakan jaringan TRON. Harap jangan mengirim dana melalui BSC, BEP20, BEP-2 atau jaringan lainnya.',
  bitpace_network_warning_LINK:
    'Silakan gunakan jaringan Ethereum (ERC20) saja. Deposit Anda akan hilang dan tidak dapat dipulihkan jika Anda tidak menggunakan jaringan Ethereum. Harap jangan mengirimkan dana melalui BSC, BEP20, BEP-2, TRC atau jaringan lainnya.',
  crypto_note_text:
    "Klien yang terhormat,<br><br>Dengan senang hati kami menginformasikan bahwa deposit dan penarikan crypto kami telah diperbarui dengan pilihan koin yang dapat dipilih, termasuk Ethereum, Ripple, Litecoin, dan lainnya. Terima kasih banyak atas kesabaran Anda, dan kami mohon maaf atas ketidaknyamanan yang ditimbulkan.<br><br><strong>Harap dicatat: Anda harus mengklik 'Buat alamat' dan menyalin alamat terbaru setiap kali Anda ingin deposit.</strong>",
  crypto_visit_page: 'Selalu kunjungi halaman ini untuk mendapatkan alamat crypto terbaru sebelum melakukan deposit.',
  pamm_statistics_text:
    'Statistik Pamm tersedia di area Klien PAMM kami Jika Anda memiliki akun PAMM, silakan klik tautan di bawah untuk dialihkan, dan gunakan data akun PAMM Anda untuk login.',
  leverage: 'Leverage',
  bitpace_network_warning_BTC_withdrawal: 'Harap pastikan alamat dompet yang dimasukkan benar dan dalam BTC. Memasukkan alamat yang salah akan menyebabkan dana Anda hilang.',
  bitpace_network_warning_LTC_withdrawal: 'Harap pastikan alamat dompet yang dimasukkan sudah benar dan dalam LTC. Memasukkan alamat yang salah akan menyebabkan dana Anda hilang.',
  bitpace_network_warning_XRP_withdrawal:
    'Harap pastikan alamat dompet yang dimasukkan sudah benar dan ada di XRP. Memasukkan alamat yang salah akan menyebabkan dana Anda hilang.',
  bitpace_network_warning_BCH_withdrawal: 'Harap pastikan alamat dompet yang dimasukkan benar dan dalam BCH. Memasukkan alamat yang salah akan menyebabkan dana Anda hilang.',
  bitpace_network_warning_USDT_withdrawal:
    'Pastikan alamat dompet yang dimasukkan benar dan berada di jaringan ERC20 atau TRC20 dan dalam USDT. Memasukkan alamat yang salah akan menyebabkan dana Anda hilang.',
  bitpace_network_warning_USDC_withdrawal:
    'Harap pastikan alamat dompet yang dimasukkan benar dan dalam jaringan ERC20 atau TRC20 dan dalam USDC. Memasukkan alamat yang salah akan menyebabkan dana Anda hilang.',
  bitpace_network_warning_TRX_withdrawal:
    'Pastikan alamat dompet yang dimasukkan benar dan berada di jaringan TRC20 dan di TRX. Memasukkan alamat yang salah akan menyebabkan dana Anda hilang.',
  bitpace_network_warning_LINK_withdrawal:
    'Harap pastikan alamat dompet yang dimasukkan benar dan berada di jaringan ERC20 atau TRC20 dan ada di LINK. Memasukkan alamat yang salah akan menyebabkan dana Anda hilang.',
}



// WEBPACK FOOTER //
// ./src/locale/id.js